import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=48baa5ca"
import script from "./TagsInput.vue?vue&type=script&lang=js"
export * from "./TagsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48baa5ca')) {
      api.createRecord('48baa5ca', component.options)
    } else {
      api.reload('48baa5ca', component.options)
    }
    module.hot.accept("./TagsInput.vue?vue&type=template&id=48baa5ca", function () {
      api.rerender('48baa5ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inputs/TagsInput.vue"
export default component.exports